interface KmRange {
  fromKm: string;
  toKm: string;
  priceAmount: string;
}
interface RateName {
  rateName?: string;
  name?: string;
}
interface Status {
  status: string;
}

type ParamOldNew = Partial<KmRange> | Partial<RateName> | Partial<Status>;

interface Parameter {
  old: ParamOldNew;
  new: ParamOldNew;
  action: string;
}

export interface LocationRateUpdate {
  rateName: string;
  deliveryType: string;
  newStatus: string;
  parameters?: Parameter[];
}

const isKmRangeFields = (obj: any): obj is KmRange =>
  typeof obj === "object" &&
  "fromKm" in obj &&
  "toKm" in obj &&
  "priceAmount" in obj;

export const hasKmRangeChanged = (param: Parameter): boolean =>
  isKmRangeFields(param.old) || isKmRangeFields(param.new);

const isRateNameFields = (obj: any): obj is RateName =>
  typeof obj === "object" && ("rateName" in obj || "name" in obj);

export const hasRateNameChanged = (param: Parameter): boolean =>
  isRateNameFields(param.old) || isRateNameFields(param.new);

export const hasRateNameChangedFromParams = (parameters: any[]): boolean =>
  parameters.some(param =>
    ["name", "rateName"].some(
      key => (param.old && key in param.old) || (param.new && key in param.new)
    )
  );

const isStatusFields = (obj: any): obj is Status =>
  typeof obj === "object" && "status" in obj;

export const hasStatusChanged = (param: Parameter): boolean =>
  isStatusFields(param.old) || isStatusFields(param.new);

export const isLocationRateUpdate = (obj: any): obj is LocationRateUpdate =>
  typeof obj === "object" &&
  "rateName" in obj &&
  "deliveryType" in obj &&
  "newStatus" in obj &&
  (!("parameters" in obj) || Array.isArray(obj.parameters));

export const getChangedLocationRangeFields = (
  oldVal: Partial<KmRange>,
  newVal: Partial<KmRange>
): string[] => {
  const changedFields: string[] = [];

  if (oldVal.fromKm !== newVal.fromKm) {
    changedFields.push("fromKm");
  }

  if (oldVal.toKm !== newVal.toKm) {
    changedFields.push("toKm");
  }

  if (oldVal.priceAmount !== newVal.priceAmount) {
    changedFields.push("priceAmount");
  }

  return changedFields;
};
